import { Navigation, Mobile, Viewport, TRANSITION_END } from './core'
import Header from './modules/header'
import Projects from './plugins/projects'
import Fancybox from '@fancyapps/fancybox'
import Scrollbar from 'smooth-scrollbar'
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll'
// import './plugins/initiatives'

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    navigation: undefined,
    projects: undefined,
    scrollbar: undefined,
    _preventFancyboxPopState: false,
  }

  /* Smooth scrollbar */
  Scrollbar.use(OverscrollPlugin);
  $.mlmi.scrollbar = Scrollbar.init($('.app').get(0), {
    alwaysShowTracks: false,
    continuousScrolling: false,
    damping: .15,
    plugins: {
      overscroll: {
        enable: true,
        effect: 'glow',
        damping: .15,
        maxOverscroll: 200,
        glowColor: '#ddd'
      },
    },
  })

  /* Viewport */
  new Viewport({
    selector: '.app',
  })

  /* Header */
  const header = Header.init()

  $(window).on('resize orientationchange load', function() {
    $('html').css('--header-height', $('.header').outerHeight(false) + 'px')
    $('.header__menu').css('--menu-height', $('.main-menu').outerHeight(false) + 'px')
  })

  $(window).on('page_load', function(event, loadedContent) {
    if (loadedContent) {
      let $response = $('<html>').html(loadedContent)
      $('head, body').attr('class', $('main').data('view'))
      $('html').css('--page-color', $('main').data('page-color'))
      $('.footer__language').html($response.find('.footer__language').html());
    }

    /* Body class */
    if ($('body').hasClass('single-project')) {
      $('.main-menu__item:eq(0)').data('main-menu-item').initialize_active()
    }

    /* Init Isotope style filtering */
    $.mlmi.projects = Projects.initFiltering()
    $('.project-categories__link').each(function() {
      $(this).selectProjectCategory()
    })

    /* Scroll to top */
    $.mlmi.scrollbar.setPosition(0, 0)

    /* Fade-in elements */
    $('.project-first-section .fade-in').removeClass('fade-in')
    $('.fade-in, .slide-in').each(function() {
      let fadeInElement = $(this).FadeIn({
        scrollChecker: false,
        smoothScrollbar: $.mlmi.scrollbar,
      })
      $.mlmi.scrollbar.addListener(fadeInElement.scrolled)
    })

    /* Make videos look like images */
    $('.video-loop').each(function() {
      let self = $(this)
      let video = $(this).find('video')
      if (video.data('loaded')) {
        setTimeout(function() {
          picture(video.get(0))
          video.get(0).play()
        }, 60)
      } else {
        video.on('canplaythrough', function() {
          picture(video.get(0))
          video.get(0).play()
        })
      }
    })

    /* Initiatives */
    $('.grid--style--laboratoire .grid__item').each(function() {
      let self = $(this)

      self.calculateCellWidth = function() {
        self.css('--cellWidth', self.innerWidth())
      }

      $(window).on('load resize orientationchange', self.calculateCellWidth)
      self.calculateCellWidth()
    })
    // $('.initiative-row').each(function() {
    //   $(this).initiatives()
    // })

    jQuery.extend(jQuery.fancybox.defaults, {
      btnTpl: {
        close:
          '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
          'Fermer' +
          "</button>",
        arrowLeft:
          '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
          '<div><i class="icon-arrow-left"></i></div>' +
          "</button>",
        arrowRight:
          '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
          '<div><i class="icon-arrow-right"></i></div>' +
          "</button>",
      },
      beforeClose: function() {
        $.mlmi._preventFancyboxPopState = true
      },
    });

    /* Media Gallery */
    $('.image-gallery').each(function(index) {
      $(this).find('[data-fancybox="gallery"]').attr('data-fancybox', 'gallery_' + index)
      $('[data-fancybox="gallery_' + index + '"]').fancybox({
        loop: true,
        buttons: ['close'],
        arrows: true,
        btnTpl: {
          close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
            'Fermer' +
            "</button>",
          arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
            '<div><i class="icon-arrow-left"></i></div>' +
            "</button>",
          arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
            '<div><i class="icon-arrow-right"></i></div>' +
            "</button>",
        },
        openEffect: 'elastic',
        closeEffect: 'elastic',
        nextEffect: 'fade',
        prevEffect: 'fade',
        beforeClose: function() {
          $.mlmi._preventFancyboxPopState = true
        },
      });
    })
  })

  $(window).on('page_exit', function() {
    /* Unload images */
    $('main').find('img').attr('src', '').remove()

    /* Scroll to top */
    $.mlmi.scrollbar.setPosition(0, 0)

    /* Close burger maybe? */
    if (!$('html').hasClass('--menu-transitioning')) {
      $('html').removeClass('--menu-open')
      header.burger.maybe_close()
    }
  })

  function openProject(link) {
    /* local variables */
    let $html = $('html'),
    $body = $('body'),
    $image = link.find('.card-project__image'),
    $animated_image = $image.clone(),
    $header = $('.header'),
    $transition = $('.page-transition'),
    start_coords = $image.get(0).getBoundingClientRect(),
    scaled_coords = $image.find('img').get(0).getBoundingClientRect(),
    header_height = parseFloat($('html').css('--header-height')),
    container_padding = parseFloat($header.css('padding-left')),
    target_ratio = parseFloat($image.find('picture').data('ratio')),
    target_width = $(window).width() - (container_padding * 2),
    target_height = target_width * target_ratio,
    current_scale = scaled_coords.width / start_coords.width

    /* animate elements */
    $animated_image.css({
      'position': 'fixed',
      'top': start_coords.y + 'px',
      'left': start_coords.x + 'px',
      'width': start_coords.width + 'px',
      'height': start_coords.height + 'px',
      'z-index': 1000,
    })
    $animated_image.find('img').css({
      'transform': 'translate(-50%, -50%) scale(' + current_scale + ')',
    })
    $transition.after($animated_image)
    $body.css('overflow', 'hidden')
    requestAnimationFrame(function() {
      const header_tween_duration = 600
      $html.removeClass('--header-minimized')
      $animated_image.animate({
        'top': header_height + 'px',
        'left': container_padding + 'px',
        'width': target_width + 'px',
        'height': target_height + 'px',
      }, header_tween_duration, 'easeInOutQuart')
      $(window).off('page_transition_ended').on('page_transition_ended', function() {
        setTimeout(function() {
          $html.removeClass('--quick-transition')
          $animated_image.fadeOut(175, function() {
            $(this).remove()
          })
          $body.css('overflow', '')
        }, 50)
      })
      $animated_image.find('.picture').animate({
        'padding-top': target_ratio + '%',
      }, header_tween_duration, 'easeInOutQuart', function() {
        $html.addClass('--quick-transition')
        $animated_image.addClass('card-project__image--loading')
      }).find('img').css({
        'transform': 'translate(-50%, -50%) scale(1)'
      })
    })
  }

  /* Navigation */
  $.mlmi.navigation = new Navigation({
    selectors: {
      pageContent: 'main',
      pageTarget: 'main',
    },
    on: {
      beforeRegisterLinks: function() {
        $('.footer a').data('preventTransition', 1)
      },
      popState: function(href, popState) {
        if ($('.project-categories').length && popState.filter != undefined) {
          $.mlmi.projects.filter(popState.filter)
          $('a[data-filter="' + popState.filter + '"]').click()
          return false
        }
        if ($.mlmi._preventFancyboxPopState) {
          return false
        }
        return true
      },
      linkClicked: function(link) {
        if (link.hasClass('card-project')) {
          openProject(link)
        } else {
          $('html').removeClass('--quick-transition')
        }
      },
    },
    filter: {
      popState: function(popState, historyAction) {
        if (historyAction == 'replaceState' || (historyAction == 'pushState' && popState.filter == undefined)) {
          if ($('.project-categories').length) {
            if (location.hash) {
              popState.filter = location.hash.replace('#', '')
            } else {
              popState.filter = 'all'
            }
          }
        }
        if (historyAction == 'popState' && $.mlmi._preventFancyboxPopState) {
          $.mlmi._preventFancyboxPopState = false
          popState.isPageTransition = false
        }
        return popState
      },
    },
  })
})
